/** arrays now have `last` and `contains` methods */
declare global {
	interface Array<T> {
		last: T
		contains: (el: T) => boolean
	}
}
Object.defineProperty(Array.prototype, "last", {
	get: function()      { return this[this.length - 1] },
	set: function(value) { return this[this.length - 1] = value }
})
Object.defineProperty(Array.prototype, "contains", {
	get: function() { return (element: any) => -1 !== this.findIndex((x: any) => x === element) },
})

// ==============================================

declare global {
	interface Number {
		pad: (n: number) => string
	}
}
Number.prototype.pad = function (n: number) { return String(this).padStart(n,'0') }
// ==============================================

// math is globally accessible
// TODO : maybe this is insane

// declare global {
// 	const π: number
// 	function cos(θ:number): number
// 	function sin(θ:number): number
// 	function exp(x:number): number
// }
// Object.defineProperty(Window.prototype, "π"  , { get: function () { return Math.PI  } })
// Object.defineProperty(Window.prototype, "cos", { get: function () { return Math.cos } })
// Object.defineProperty(Window.prototype, "sin", { get: function () { return Math.sin } })
// Object.defineProperty(Window.prototype, "exp", { get: function () { return Math.exp } })

// ==============================================

/** @internal */ const dateStart = Date.now()
/** gives time from page load in seconds */ export function getTime() { return (Date.now() - dateStart) * 0.001 }
declare global {
	const time: number
}
Object.defineProperty(Window.prototype, "time", { get: () => getTime() })

// ==============================================

/** enhance canvas with a function that matches the resolution with displayed resolution */
declare global {
	interface HTMLCanvasElement {
		resize: (multiplier: number) => boolean
	}
}
Object.defineProperty(HTMLCanvasElement.prototype, "resize", {
	get: function () {
		return (multiplier: number = 1) => {
			const width  = Math.floor(this.clientWidth  * multiplier)
			const height = Math.floor(this.clientHeight * multiplier)
			if (this.width !== width || this.height !== height) {
				this.width = width
				this.height = height
				return true
			}
			return false
		}
	}
})

// ==============================================

// twgl is easy to access
// const m4 = twgl.m4
// const v3 = twgl.v3

// export function generateId() {
// 	return (new Date()).getTime() + '-' + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)
// }

// let zip = (x,y,z,w) => {
// 	let out = []
// 	let   I = x.length < y.length ?x:y
// 	if(z) I = I.length < z.length ?I:z
// 	if(w) I = I.length < z.length ?I:w
// 	for(let i in I) {
// 		out.push(x[i])
// 		out.push(y[i])
// 		if(z) out.push(z[i])
// 		if(w) out.push(w[i])
// 	}
// 	return out
// }
